import { render, staticRenderFns } from "./RiskTip.vue?vue&type=template&id=b6ab2c5a&scoped=true&"
import script from "./RiskTip.vue?vue&type=script&lang=js&"
export * from "./RiskTip.vue?vue&type=script&lang=js&"
import style0 from "./RiskTip.vue?vue&type=style&index=0&id=b6ab2c5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ab2c5a",
  null
  
)

export default component.exports